/**
 * A clickable link to a diamond's lab grading report, built from the grading
 * lab + report number we already hold on every stone (`lab`, `certNo`).
 *
 * Buyers asked to click the report number and land on the ACTUAL report, not
 * just read the digits (Tej 2026-10-21):
 *   • IGI → the report PDF, served straight off IGI's CDN at
 *           https://pdf.igi.org/ID<number>.pdf — opens the real report.
 *   • GIA → GIA Report Check, which confirms the number against GIA's archive.
 *   • anything else / unknown lab / no number → null, and the caller renders the
 *     number as plain text exactly as before. We never fabricate a link we
 *     can't stand behind.
 *
 * Kept deliberately small + pure so every render surface (desktop modal, spec
 * sheet, table, mobile detail, public share page) links identically, and so a
 * new lab is a one-line addition here.
 */
export function labReportUrl(
  lab: string | null | undefined,
  certNo: string | null | undefined,
): string | null {
  const num = (certNo ?? '').trim().replace(/\s+/g, '')
  if (!num) return null
  // Normalize the lab name to bare letters so "IGI", "igi", "I.G.I." all match.
  const normLab = (lab ?? '').toUpperCase().replace(/[^A-Z]/g, '')
  if (normLab.includes('IGI')) return `https://pdf.igi.org/ID${encodeURIComponent(num)}.pdf`
  if (normLab.includes('GIA')) return `https://www.gia.edu/report-check?reportno=${encodeURIComponent(num)}`
  return null
}
